<template>
  <Modal
    width="920"
    :title="title"
    class-name="c-document vertical-center-modal"
    v-model="state"
    :mask-closable="false"
    :closable="false"
    @on-visible-change="bindGetData"
  >
    <el-form v-if="state" inline v-highlight class="elementui-common-form-styles">
      <el-form-item>
        <el-select
          v-model="opId"
          style="width: 180px"
          @change="search"
          :popper-append-to-body="false"
          clearable
          filterable
          placeholder="全部"
        >
          <el-option v-for="item in CAOHUA_OPEN_USERS" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="游戏">
        <el-select
          v-model="gameId"
          style="width: 180px"
          @change="search"
          :popper-append-to-body="false"
          clearable
          filterable
          placeholder="全部"
        >
          <el-option v-for="item in GAMES" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-input v-model.trim="keyword" placeholder="请输入文案内容或ID" @keyup.enter.native="search">
          <i slot="append" @click="search" class="el-icon-search"></i>
        </el-input>
      </el-form-item>
    </el-form>

    <div>
      <Spin size="large" fix v-if="show"></Spin>
      <Table
        ref="table"
        height="440"
        stripe
        :columns="columns"
        :data="docDataList"
        @on-row-click="rowClick"
        @on-select="selectRow"
        @on-select-all="selectAll"
        @on-select-cancel="cancelRow"
        @on-select-all-cancel="cancelAll"
      ></Table>
      <Page class="page-index" show-total :current.sync="pageIndex" :total="total" :page-size="pageSize" @on-change="changePageIndex" />
    </div>
    <div style="text-align: right" slot="footer" :gutter="12">
      <Button type="default" @click="$emit('on-cancel')">取消</Button>
      <Button type="primary" @click="save">确定</Button>
    </div>
  </Modal>
</template>
<script>
import Cookies from 'js-cookie'
import { setLocal, getLocal } from '@/common/js/api'
import { isArray } from '@/common/js/utils'
import { listPlanDocument } from '@/api/manage.model'
import { adGames } from '@/api/common.model'
import columns from './columns.json'
import { initPageData, PROJECT_GROUP, GAMES, CAOHUA_OPEN_USERS } from '@/data/global-opts'
const PAGE_REQUIRED_OPTS = initPageData([PROJECT_GROUP, GAMES, CAOHUA_OPEN_USERS])

export default {
  name: 'idocument',
  props: {
    value: {
      type: Boolean
    },
    openId: {
      type: [Number, String]
    },
    singleChoice: {
      type: Boolean
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS,
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    len() {
      return this.defaultData.length
    },
    title() {
      return `文案选择  ${this.len ? '(已选' + this.len + '条)' : ''}`
    }
  },
  methods: {
    bindGetData(val) {
      if (!val) {
        this.docDataList = []
        this.defaultData = [] // 选中的文案
        this.keyword = ''
        this.gameId = ''
        this.opId = ''
        this.pageIndex = 1
      } else if (!this.docDataList.length) {
        // this.getData()
        this.setOpenId()
      }
    },
    rowClick(data, index) {
      this.$refs.table.toggleSelect(index)
    },
    selectRow(selection, row) {
      const idx = this.docDataList.findIndex((ret) => ret.docId === row.docId)
      // 单选
      if (this.singleChoice) {
        this.docDataList.forEach((ret) => {
          this.$set(ret, '_checked', false)
        })
        if (idx > -1) {
          this.$set(this.docDataList[idx], '_checked', true)
          this.defaultData = [row]
        }
      } else this.defaultData.push(row)
    },
    selectAll() {
      this.docDataList.forEach((ret) => {
        this.selectRow([], ret)
      })
    },
    cancelRow(selection, row) {
      const index = this.defaultData.findIndex((ret) => ret.id === row.id)
      if (index > -1) this.defaultData.splice(index, 1)
    },
    cancelAll() {
      this.docDataList.forEach((ret) => {
        this.cancelRow([], ret)
      })
    },
    search() {
      this.pageIndex = 1
      this.getData({ keyWord: this.keyword })
    },
    getData(search) {
      if (!this.state) return
      let params = {
        keyWord: this.keyword,
        page_id: this.pageIndex,
        page_size: this.pageSize,
        gameId: this.gameId,
        opId: this.opId
      }
      if (search) params = Object.assign(params, search)

      this.show = true
      listPlanDocument(params).then((data) => {
        this.show = false
        if (data && isArray(data.list) && data.page_info) {
          const { total_number } = data.page_info
          this.total = total_number
          this.docDataList = data.list.map((ret) => {
            ret._checked = this.defaultData.map((met) => met.docId).includes(ret.docId)
            return ret
          })
        }
      })
    },
    preLoadData() {
      adGames().then((data) => {
        isArray(data) && (this.gameData = data)
        this.gameData.unshift({ id: 0, name: '通用' })
      })
    },
    setOperatorStorage(name, value) {
      const account = this.openId || Cookies.get('ch_op_id')
      const storage = getLocal(name) || {}
      if (account) {
        storage[account] = value
        setLocal(name, storage)
      }
    },
    setOpenId() {
      const account = this.openId || ''
      const storage = getLocal('select-document')
      this.opId = storage && storage[account] ? storage[account] : account
    },
    changePageIndex(index) {
      this.pageIndex = index
      this.getData()
    },
    changeOperator(meta) {
      this.opId = meta.id
    },
    changeGame(meta) {
      this.gameId = meta.id
    },
    save() {
      if (this.defaultData.length) {
        // 记录上次成功opId
        this.setOperatorStorage('select-document', this.opId || -1)
        this.$emit('on-select', this.defaultData)
      } else this.$Message.warning('您未选择一个文案')
    }
  },
  data() {
    return {
      show: null,
      keyword: '',
      total: 0,
      pageIndex: 1,
      pageSize: 10,
      columns: columns,
      opId: '',
      gameId: '',
      gameData: [],
      docDataList: [],
      defaultData: []
    }
  },
  created() {
    this.preLoadData()
  }
}
</script>
<style lang="scss" scoped>
.c-document {
  position: relative;

  .filter-box {
    margin-bottom: 15px;

    ::v-deep .ivu-form-item {
      margin-bottom: 0;
    }
  }

  .page-index {
    margin-top: 12px;
    text-align: right;
  }
}
</style>
